import { createContext } from "react";

import { type ApiMagentoPriceTier } from "@jti/magento-types";

export type TPriceTiersContext = {
  singleProductPrice: number | null;
  selectedPriceTier: ApiMagentoPriceTier | null;
  setSelectedPriceTier: (priceTier: ApiMagentoPriceTier) => void;
};

export const PriceTiersContext = createContext<TPriceTiersContext>({
  singleProductPrice: null,
  selectedPriceTier: null,
  setSelectedPriceTier: () => undefined,
});
